
















































































































































































































































































































































import ActivityTimeLine from "@/components/partner/ActivityTimeLine.vue";
import PartnerReportDetailChangeProgress from "@/components/partner/PartnerReportDetailChangeProgress.vue";
import PartnerReportDetailDeleteDialog from "@/components/partner/PartnerReportDetailDeleteDialog.vue";
import SendToExternOption from "@/components/partner/PartnerReportDetailSendToExternOption.vue";
import ReportActivityBoxCommentComponent from "@/components/partner/ReportActivityBoxCommentComponent.vue";
import ReportActivityShareDialog from "@/components/partner/ReportActivityShareDialog.vue";
import TemplateDialog from "@/components/template/TemplateDialog.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MHeader, { IAction, IAlert, IChips } from "@/components/utility/mmmint/MHeader.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import SideCard from "@/components/utility/SideCard.vue";
import { getFlagEmojiByLanguage } from "@/lib/CountryCodeHelper";
import { ApplicationInsightsEventEnum } from "@/lib/enum/application-insights-event.enum";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { ActivityLogModule } from "@/store/modules/activity-log.store";
import { FeatureModule } from "@/store/modules/feature.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import PartnerReportDetailClaimSettlement from "./PartnerReportDetailClaimSettlement.vue";
import PartnerReportDetailContact from "./PartnerReportDetailContact.vue";
import PartnerReportDetailDamage from "./PartnerReportDetailDamage.vue";
import PartnerReportDetailDocument from "./PartnerReportDetailDocument.vue";
import PartnerReportDetailGroup from "./PartnerReportDetailGroup.vue";
import PartnerReportDetailInvoice from "./PartnerReportDetailInvoice.vue";
import PartnerReportDetailRental from "./PartnerReportDetailRental.vue";
import PartnerReportDetailRepair from "./PartnerReportDetailRepair.vue";
import PartnerReportDetailTicket from "./PartnerReportDetailTicket.vue";
import PartnerReportDetailVehicle from "./PartnerReportDetailVehicle.vue";
import { ReportGoToHelper, ReportRouteNames } from "@/lib/utility/report.go-to-helper";
import aiService from "@/services/mrfiktiv/services/aiService";
import { handleError } from "@/lib/utility/handleError";
import { RawLocation } from "vue-router";
import AEiLoading from "@/components/utility/AEiLoading.vue";
import PartnerReportDetailMessage from "./PartnerReportDetailMessage.vue";

export enum ReportTabs {
  DAMAGE = "damage",
  VEHICLE = "vehicle",
  REPAIR = "repair",
  RENTAL = "rental",
  INVOICE = "invoice",
  DOCUMENT = "document",
  MESSAGE = "message",
  CONTACT = "contact",
  TICKET = "ticket",
  CLAIM_SETTLEMENT = "claim_settlement",
  REPORT_GROUP = "report_group"
}

@Component({
  components: {
    MHeader,
    MSelect,
    MTextField,
    MIconButton,
    PartnerReportDetailChangeProgress,
    PartnerReportDetailRepair,
    PartnerReportDetailDamage,
    PartnerReportDetailRental,
    PartnerReportDetailInvoice,
    PartnerReportDetailVehicle,
    PartnerReportDetailDocument,
    PartnerReportDetailMessage,
    PartnerReportDetailContact,
    PartnerReportDetailTicket,
    TemplateDialog,
    ReportActivityShareDialog,
    SendToExternOption,
    PartnerReportDetailDeleteDialog,
    SideCard,
    ActivityTimeLine,
    ReportActivityBoxCommentComponent,
    ConfirmActionDialog,
    PartnerReportDetailClaimSettlement,
    PartnerReportDetailGroup,
    AEiLoading
  },
  filters: { simpleDoubleDigitDate, getFlagEmojiByLanguage }
})
export default class PartnerReportDetail extends mixins(PermissionMixin) {
  getFlagEmojiByLanguage = getFlagEmojiByLanguage;

  tab = 0;
  readonly = true;
  ReportTabs = ReportTabs;

  isActivityOpen = false;
  isDriverDialogOpen = false;

  isSummaryDialogActive = false;
  summary: string | null = null;
  summaryLoading = false;
  isLoadingSharingDialog = false;

  isDriverDialogEdit = false;
  isDriverLoading = false;

  @Prop({ default: true })
  showBreadcrumbs!: boolean;

  @Prop({ default: false })
  showDetailButton!: boolean;

  get isTimeLine() {
    return FeatureModule.isTimeLine;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get attachmentFileFilters() {
    return this.report?.refFilter || [];
  }

  get activityLog() {
    return ActivityLogModule.filteredAndSorted;
  }

  get title() {
    return this.report.title;
  }

  get subtitle() {
    return this.report.timestamp.createdReadable;
  }

  get createdBy() {
    if (!this.report.userId) {
      return undefined;
    }

    return PartnerUserModule.maps.id.get(this.report.userId)[0];
  }

  get templateDialogMethods() {
    return {
      context: {
        partner: this.partner,
        report: this.report
      },
      to: [this.report.customerContact?.email || ""],
      from: [this.partner]
    };
  }

  get breadCrumbs(): IBreadcrumb[] | undefined {
    const breadCrumbs: IBreadcrumb[] = [];

    if (!this.showBreadcrumbs) {
      return breadCrumbs;
    }

    breadCrumbs.push({
      text: this.$t("nav.PartnerReports.title"),
      exact: true,
      disabled: false,
      to: {
        name: "PartnerReports",
        params: {
          partnerId: this.report.partnerId
        }
      }
    });

    breadCrumbs.push({
      text: this.report.title ?? this.report.numberplate,
      exact: true,
      disabled: false,
      to: {
        name: "PartnerReportsDetailView",
        params: {
          partnerId: this.report.partnerId,
          reportId: this.report.id
        }
      }
    });

    return breadCrumbs;
  }

  get chips(): IChips[] {
    const chips: IChips[] = [];

    if (this.report.totalLoss) {
      chips.push({
        key: "totalLoss",
        text: this.$t("objects.report.totalLoss").toString(),
        tooltip: this.$t(`enums.TotalLossType.${this.report.totalLoss}`).toString(),
        color: "error"
      });
    }

    if (this.report.claimNumber) {
      chips.push({
        key: "claimNumber",
        text: this.report.claimNumber,
        exec: () => {
          if (this.report.claimNumber) {
            navigator.clipboard.writeText(this.report.claimNumber);
            this.$toast.info(this.$t("components.CopyClipboardText.confirmCopy"));
          }
        },
        tooltip: this.$t("sign.SignInitializeCard.copy").toString()
      });
    }

    if (this.report.externalId) {
      chips.push({
        key: "externalId",
        text: this.report.externalId,
        exec: () => {
          if (this.report.externalId) {
            navigator.clipboard.writeText(this.report.externalId);
            this.$toast.info(this.$t("components.CopyClipboardText.confirmCopy"));
          }
        },
        tooltip: this.$t("sign.SignInitializeCard.copy").toString()
      });
    }

    return chips;
  }

  get alerts(): IAlert[] {
    const alerts: IAlert[] = [];

    return alerts;
  }

  get actions() {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: this.$t("common.nouns.detail").toString(),
        key: "detail",
        icon: "mdi-open-in-new",
        exec: () =>
          new ReportGoToHelper(this.$router).goToReportDetail({
            partnerId: this.report.partnerId,
            reportId: this.report.id,
            newTab: false
          })
      });
    }

    actions.push({
      text: this.$t("objects.activityLog.activity").toString(),
      key: "COMMENT",
      icon: "mdi-bell-outline",
      exec: () => (this.isActivityOpen = true)
    });

    actions.push({
      text: this.$t("common.nouns.email").toString(),
      key: "MAIl",
      icon: "mdi-email-outline",
      exec: () => (this.$refs.templateDialog as TemplateDialog).show()
    });

    actions.push({
      text: String(this.$t("share")),
      key: "SHARE",
      icon: "mdi-share-outline",
      loading: this.isLoadingSharingDialog,
      exec: () => {
        this.isLoadingSharingDialog = true;
        (this.$refs.shareDialog as ReportActivityShareDialog).show().finally(() => {
          this.isLoadingSharingDialog = false;
        });
      }
    });

    if (UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.AI, this.report.partnerId)) {
      actions.push({
        text: String(this.$t("common.verbs.summarize")),
        key: "summarize",
        icon: "mdi-creation",
        color: "success",
        exec: this.summarizeReport
      });
    }

    if (this.can(ActionEnum.DELETE, ResourceEnum.REPORT)) {
      actions.push({
        text: String(this.$t("common.verbs.delete")),
        key: "DELETE",
        icon: "mdi-trash-can",
        color: "error",
        exec: () => (this.$refs.deleteDialog as PartnerReportDetailDeleteDialog).show()
      });
    }

    return actions;
  }

  get canReadRepair() {
    return (
      UserModule.abilities.can(ActionEnum.READ, ResourceEnum.REPAIR_ESTIMATE, PartnerModule.partner.id) ||
      UserModule.abilities.can(ActionEnum.READ, ResourceEnum.APPRAISAL, PartnerModule.partner.id) ||
      UserModule.abilities.can(ActionEnum.READ, ResourceEnum.CLEARANCE, PartnerModule.partner.id)
    );
  }

  get canReadContact() {
    return (
      UserModule.abilities.can(ActionEnum.READ, ResourceEnum.PERSON, PartnerModule.partner.id) ||
      UserModule.abilities.can(ActionEnum.READ, ResourceEnum.COMPANY, PartnerModule.partner.id)
    );
  }

  get canReadClaimSettlement() {
    return this.partner.partnerType === PartnerTypeEnum.BROKER;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get tabs() {
    const tabs = [ReportTabs.DAMAGE];

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.VEHICLE, PartnerModule.partner.id)) {
      tabs.push(ReportTabs.VEHICLE);
    }

    if (this.canReadRepair) {
      tabs.push(ReportTabs.REPAIR);
    }

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.RENTAL, PartnerModule.partner.id)) {
      tabs.push(ReportTabs.RENTAL);
    }

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.INVOICE, PartnerModule.partner.id)) {
      tabs.push(ReportTabs.INVOICE);
    }

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.DOCUMENT, PartnerModule.partner.id)) {
      tabs.push(ReportTabs.DOCUMENT);
    }

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.MESSAGE_INBOUND, PartnerModule.partner.id)) {
      tabs.push(ReportTabs.MESSAGE);
    }

    if (this.canReadContact) {
      tabs.push(ReportTabs.CONTACT);
    }

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.TICKET, PartnerModule.partner.id)) {
      tabs.push(ReportTabs.TICKET);
    }

    if (this.canReadClaimSettlement) {
      tabs.push(ReportTabs.CLAIM_SETTLEMENT);
    }

    if (this.can(ActionEnum.READ, ResourceEnum.REPORT_GROUP)) {
      tabs.push(ReportTabs.REPORT_GROUP);
    }

    return tabs;
  }

  get whatsappLink() {
    if (!this.report?.customerContact?.phone) {
      return undefined;
    }

    const whatsappPhoneNumber = this.report?.customerContact.phone.trim().replace(" ", "");

    return `https://wa.me/${whatsappPhoneNumber}?text=''`;
  }

  openWhatsapp() {
    this.$appInsights.trackEvent(
      { name: ApplicationInsightsEventEnum.OPEN_WHATSAPP },
      { partnerId: PartnerModule.partner.id }
    );

    window.open(this.whatsappLink, "Whatsapp", "width=600,height=300");
  }

  getTabId(fleetTab: ReportTabs) {
    return this.tabs.indexOf(fleetTab);
  }

  setTab(tab?: ReportTabs) {
    if (tab) {
      const index = this.tabs.indexOf(tab as ReportTabs);

      if (index > -1) {
        return (this.tab = index);
      }
    }

    return (this.tab = 0);
  }

  /**
   * Listens for tab changes.
   * Use history API to update just the URL without navigation.
   */
  @Watch("tab")
  syncRoute() {
    const query = {
      reportId: this.report.id,
      tab: this.tabs[this.tab] ?? ""
    };
    const currentLocationName = this.$route.name;
    const currentLocationParams = this.$route.params;
    const currentLocationQuery = this.$route.query;

    const to: RawLocation = {
      name: currentLocationName || ReportRouteNames.REPORT_DETAIL,
      params: currentLocationParams,
      query: { ...currentLocationQuery, ...query }
    };

    new ReportGoToHelper(this.$router).setUrl(to);
  }

  async processAction(action: IAction) {
    this.$log.debug(action);
  }

  mounted() {
    const tab = this.$route.query.tab ?? ReportTabs.DAMAGE;
    this.setTab(tab as ReportTabs);

    this.$log.debug(tab);
  }

  openMail() {
    (this.$refs.templateDialog as TemplateDialog).show();
  }

  /**
   * improve data handling by fetching data when report changes
   */
  @Watch("report", { immediate: true })
  async onReportChanged() {
    this.$log.debug(`PartnerReportDetail.onReportChanged: ${this.report?.id}`);

    if (!this.report.id) {
      this.$log.debug("Report ID is not set, skipping data fetch.");
      return;
    }

    if (this.canReadReportGroup) {
      this.report.fetchReportGroup().catch(this.$log.error);
    }

    if (this.canReadPerson) {
      this.report.fetchPersons().catch(this.$log.error);
    }

    if (this.canReadRepairEstimate) {
      this.report.fetchCostEstimates().catch(this.$log.error);
    }

    if (this.canReadAppraisal) {
      this.report.fetchAppraisals().catch(this.$log.error);
    }

    if (this.canReadClearance) {
      this.report.fetchClearances().catch(this.$log.error);
    }

    if (this.canReadCompany) {
      this.report
        .fetchCompanies()
        .then(() => {
          if (this.report.workShopCompany && this.canReadContact) {
            this.report.workShopCompany?.fetchContracts().catch(this.$log.error);
          }
        })
        .catch(this.$log.error);
    }

    if (this.report.fleetId && this.canReadFleet) {
      this.report.fetchFleet().then(() => {
        if (this.canReadCompany) {
          this.report.fleet?.fetchCompany();
          this.report.fleet?.fetchCompanies();
        }

        if (this.canReadContract) {
          this.report.fleet?.fetchContracts();
        }
      });
    }

    if (this.canReadRental) {
      this.report
        .fetchRentals()
        .then(() => {
          if (this.canReadDocument) {
            for (const rental of this.report.rentals) {
              if (rental.documentId) {
                rental.fetchDocument().catch(this.$log.error);
              }
            }
          }
        })
        .catch(this.$log.error);
    }
  }

  closeDriverDialog() {
    this.isDriverDialogEdit = false;
    this.isDriverDialogOpen = false;
  }

  async saveCustomerInfo() {
    this.isDriverLoading = true;
    try {
      await this.report.updatePartial({
        customerName: `${this.report.firstName} ${this.report.lastName}`,
        firstName: this.report.firstName,
        lastName: this.report.lastName,
        customerContact: {
          phone: this.report.customerContact.phone,
          email: this.report.customerContact.email
        },
        companyName: this.report.companyName
      });

      this.$toast.success("👍");
      this.closeDriverDialog();
    } catch (error) {
      handleError(error);
    } finally {
      this.isDriverLoading = false;
    }
  }

  async summarizeReport() {
    try {
      this.summaryLoading = true;
      this.isSummaryDialogActive = true;
      this.summary = "";

      const result = await aiService.getReportSummary(this.report.partnerId, this.report.id, true);
      this.$log.info(result);

      if (result) {
        this.summary = result.summary ?? null;
        this.report.summary = result.summary;
      } else {
        this.$toast.warning(this.$t("components.partner.PartnerReportDetail.summarize"));
      }
    } catch (e) {
      handleError(e);
    } finally {
      this.summaryLoading = false;
    }
  }
}
